<div class="mobile-menu-overlay">
    
    <div class="menu-content-box">
      <!-- @if (isLoggedIn) {
      <div class="profile-row">
        <img [src]="avatarUrl" alt="Avatar" class="avatar" />
        <div class="profile-info">
          <span class="greeting">Buenos días</span>
          <span class="name">{{ loggedUserName }}</span>
        </div>
      </div>
      <hr class="separator" />
      } -->
      <nav class="nav-links">
        <a class="nav-item" routerLink="/promotor-dashboard" (click)="closeMenu()">
          Inicio
        </a>
        <a class="nav-item" routerLink="/promotor-my-data" (click)="closeMenu()">
          Mis Datos
        </a>
        <a class="nav-item" routerLink="/promotor-wallet" (click)="closeMenu()">
          Wallet
        </a>

        <div class="nav-item-wrapper" [class.open]="bookingsSubmenuOpen">
          <a style="display: flex; justify-content: space-between; align-items: center; width: 100%;"
            class="nav-item has-submenu"
            tabindex="0"
            (click)="toggleBookingSubmenu($event) "
            (keydown.enter)="toggleBookingSubmenu($event) "
          >
            Reservas
            <button
            class="submenu-toggle"
            
            aria-label="Abrir Submenú de servicios">
            <i
              [class]="bookingsSubmenuOpen ? 'pi pi-angle-up' : 'pi pi-angle-down'"
            ></i>
            </button>
          </a>
          
        </div>

        @if (bookingsSubmenuOpen) {
        <div class="submenu">
          <a class="submenu-item" routerLink="/promotor-bookings" (click)="closeMenu()">
            Disponibles
          </a>
          <a
            class="submenu-item"
            routerLink="/promotor-member-booking-feature/active-bookings" (click)="closeMenu()" >
            Reservados
          </a>
          <a
            class="submenu-item"
            routerLink="/promotor-member-booking-feature/booking-history" (click)="closeMenu()" >
            Historico
          </a>
        </div>
        }
        <a class="nav-item" routerLink="/promotor-fullday" (click)="closeMenu()">
          Fullday
        </a>
        <a class="nav-item" routerLink="/promotor-my-benefits" (click)="closeMenu()">
          Beneficios
        </a>
        <a class="nav-item" routerLink="/promotor-my-clients" (click)="closeMenu()">
          Mis Clientes
        </a>
        <a class="nav-item" routerLink="/promotor-my-commissions" (click)="closeMenu()">
          Mis Comisiones
        </a>
        <a class="nav-item" routerLink="/promotor-courses" (click)="closeMenu()">
          Cursos
        </a>
      </nav>

      <div class="menu-footer">
        <div class="info-row">
          <img
            src="/header/navbar/Return.svg"
            alt="Return"
            class="icon email-icon"
          />
          <span>Pagina Web</span>
        </div>
        
        @if(isLoggedIn) {
          <lib-ribera-default-btn
          icon="header/navbar/login.svg"
          variant="primary"
          size="large"
          (press)="closeMenu(); logoOut()"
          >Cerrar Sesión</lib-ribera-default-btn
        >

        }@else {
          <lib-ribera-default-btn
          icon="header/navbar/login.svg"
          variant="outline"
          size="large"
          (press)="closeMenu(); goToLogin()"
          >Iniciar sesión</lib-ribera-default-btn
        >
        }
      </div>
    </div>
  </div>
